import React, { useState, useEffect } from 'react'
import axios from 'axios'
import {
  TextField
} from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { checkErrorStatus, setSnackbar } from 'utils/common/actions'
import { getIdArray } from 'helpers/dataHelpers'
import Autocomplete from '@material-ui/lab/Autocomplete'
import Config from 'config'


const GroupsInput = (props) => {
  const {
    error,
    helperText,
    setValue,
    defaultValue,
    single,
    variant,
    additionalClasses,
    required,
    controlledGroups,
    InputLabelProps,
    placeholder,
    label
  } = props
  const { apiUrl } = Config.network
  const dispatch = useDispatch()
  const [groups, setGroups] = useState([])
  const [value, setLocalValue] = useState(single ? null : [])
  const [inputValue, setInputValue] = useState('')

  useEffect(() => {
    if (defaultValue) {
      setLocalValue(defaultValue)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (single && controlledGroups !== undefined) {
      setLocalValue(controlledGroups)
    } else if (controlledGroups && controlledGroups.length > 0) {
      setLocalValue(controlledGroups)
      if (!single) {
        setValue(getIdArray(controlledGroups))
      } else {
        setValue(controlledGroups)
      }
    }
  }, [controlledGroups]) // eslint-disable-line react-hooks/exhaustive-deps

  const getGroups = (search) => {
    const url = `${apiUrl}groups/`
    const params = {}
    if (search) {
      params['search'] = search
    }
    axios.get(url, { params }).then((body) => {
      const { data } = body
      setGroups(data.results)
    }).catch(error => {
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }

  useEffect(() => {
    getGroups(inputValue)
  }, [inputValue]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getGroups()
    if (defaultValue) {
      if (!single) {
        setValue(getIdArray(defaultValue))
      } else {
        setValue(defaultValue)
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (event, newValue) => {
    setInputValue('')
    setLocalValue(newValue)
    if (!single) {
      setValue(getIdArray(newValue))
    } else {
      setValue(newValue)
    }
  }

  return (
    <Autocomplete
      value={value}
      onChange={handleChange}
      onInputChange={
        (event) => {
          if (event) {
            setInputValue(event.target.value)
          }
        }
      }
      getOptionSelected={(option, value) => option.id === value.id}
      multiple={!single}
      filterSelectedOptions
      options={groups}
      className={additionalClasses || ''}
      autoHighlight
      fullWidth
      getOptionLabel={(group) => group.name}
      renderOption={(group) => (
        <React.Fragment>
          {group.name}
        </React.Fragment>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          InputLabelProps={InputLabelProps}
          placeholder={placeholder || 'Filter by: Group'}
          color='secondary'
          label={label || 'Groups'}
          variant={variant || 'outlined'}
          fullWidth
          required={!!required}
          error={error}
          helperText={helperText}
          name='groups'
        />
      )}
    />
  )
}

export default GroupsInput
